import { _ as _ts_decorate } from "@swc/helpers/_/_ts_decorate";
import { _ as _ts_metadata } from "@swc/helpers/_/_ts_metadata";
import { computed, flow, makeObservable, observable } from "mobx";
import { BaseOptions } from "@devowl-wp/utils";
import { request } from "../utils/request.js";
import { locationRestChecklistGet } from "../wp-api/checklist.get.js";
import { locationRestChecklistPut } from "../wp-api/checklist.put.js";
class ChecklistStore extends BaseOptions {
    busyChecklist = false;
    checklist;
    rootStore;
    constructor(rootStore){
        super();
        makeObservable(this);
        this.rootStore = rootStore;
    }
    get items() {
        return this.checklist && Object.keys(this.checklist.items).map((id)=>({
                id,
                ...this.checklist.items[id]
            })) || [];
    }
    get completed() {
        return this.items.filter(({ checked })=>checked);
    }
    get checkable() {
        const { isPro } = this.rootStore.optionStore.others;
        return this.items.filter(({ needsPro })=>!needsPro || isPro && needsPro);
    }
    get done() {
        return this.completed.length >= this.checkable.length || !!this.checklist?.dismissed;
    }
    probablyFetchByChangedItem = flow(function*(itemId, force) {
        if (force) {
            yield this.fetchChecklist();
            return;
        }
        const useItemIds = !Array.isArray(itemId) ? [
            itemId
        ] : itemId;
        if (this.items.filter(({ id, checked })=>useItemIds.indexOf(id) > -1 && !checked).length > 0) {
            yield this.fetchChecklist();
        }
    });
    fetchChecklist = flow(function*() {
        this.busyChecklist = true;
        try {
            this.checklist = yield request({
                location: locationRestChecklistGet,
                sendReferer: true
            });
        } catch (e) {
            console.log(e);
            throw e;
        } finally{
            this.busyChecklist = false;
        }
    });
    toggleChecklistItem = flow(function*(id, state) {
        this.busyChecklist = true;
        try {
            this.checklist = yield request({
                location: locationRestChecklistPut,
                request: {
                    state
                },
                sendReferer: true,
                params: {
                    id
                }
            });
        } catch (e) {
            console.log(e);
            throw e;
        } finally{
            this.busyChecklist = false;
        }
    });
}
_ts_decorate([
    observable
], ChecklistStore.prototype, "busyChecklist", void 0);
_ts_decorate([
    observable,
    _ts_metadata("design:type", typeof ResponseRouteChecklistGet === "undefined" ? Object : ResponseRouteChecklistGet)
], ChecklistStore.prototype, "checklist", void 0);
_ts_decorate([
    computed,
    _ts_metadata("design:type", void 0),
    _ts_metadata("design:paramtypes", [])
], ChecklistStore.prototype, "items", null);
_ts_decorate([
    computed,
    _ts_metadata("design:type", void 0),
    _ts_metadata("design:paramtypes", [])
], ChecklistStore.prototype, "completed", null);
_ts_decorate([
    computed,
    _ts_metadata("design:type", void 0),
    _ts_metadata("design:paramtypes", [])
], ChecklistStore.prototype, "checkable", null);
_ts_decorate([
    computed,
    _ts_metadata("design:type", void 0),
    _ts_metadata("design:paramtypes", [])
], ChecklistStore.prototype, "done", null);
export { ChecklistStore };
